"use client";

import { useEffect, useRef } from "react";
import { useServerInsertedHTML } from "next/navigation";

const scriptId = "service-landing-structured-data";

/** Insert into the initial HTML head and keep it current on client navigation. */
export function ServiceStructuredData({ json }: { json: string }) {
  const inserted = useRef(false);

  useServerInsertedHTML(() => {
    if (inserted.current) return null;
    inserted.current = true;
    return <script id={scriptId} type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
  });

  useEffect(() => {
    const script = document.getElementById(scriptId) ?? document.createElement("script");
    script.id = scriptId;
    script.setAttribute("type", "application/ld+json");
    script.textContent = json;
    if (!script.isConnected) document.head.appendChild(script);
    return () => script.remove();
  }, [json]);

  return null;
}
